import { createElement } from "react";
import React from "react";
import * as react from "react";
import { ContextProvider, ContextMsg, useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { Track, User, Title, toastServerError, Workplace } from "./ApiClient.jsx";
import { errorToast } from "./Toasts.jsx";
import { Spinner, webLightTheme, FluentProvider, Divider, DialogActions, Text as Text$, Option, Dropdown, Field, Body1Strong, Caption1, tokens, DialogContent, Button, DialogTitle, DialogBody, DialogSurface, Dialog } from "@fluentui/react-components";
import { equals, createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Role, UpdatedUser, UserState } from "./Shared/SharedModels.jsx";
import { take, length, empty, iterate, tryHead, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { SendRegular, HourglassHalfRegular, SignOutRegular } from "@fluentui/react-icons";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { toArray, map, defaultArg } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { map as map_1, tryFind } from "./fable_modules/fable-library-js.4.29.0/Array.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { RouterModule_router, RouterModule_urlSegments } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { injectCss } from "./Helpers.jsx";
import { Sidebar } from "./Sidebar.jsx";
import { RoleBanner } from "./RoleBanner.jsx";
import { Headerbar } from "./Headerbar.jsx";
import { View } from "./CurrentPage.jsx";
import { pageFromUrl } from "./Routes.jsx";
import { createRoot } from "react-dom/client";

function ApproveUserDialog(user) {
    let elems_11, el_46, elems_10, el_44, elems_9, elemsToUse;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState([]);
    const workplaces = patternInput_1[0];
    const patternInput_2 = reactApi.useState([]);
    const titles = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const selectedWorkplace = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const selectedTitle = patternInput_4[0];
    useEffectOnce(() => {
        let pr_3;
        const pr_2 = startAsPromise(Workplace.GetEnabledWorkplaces());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Kunne ikke hente arbeidsplasser", "Noe gikk galt", undefined);
            }
            else {
                patternInput_1[1](res_1.fields[0]);
            }
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        let pr_5;
        const pr_4 = startAsPromise(Title.GetAllTitles());
        pr_5 = (pr_4.then((res_2) => {
            if (res_2.tag === 1) {
                errorToast(setCtx, "fetchTitlesError", "Kunne ikke hente titler", "Noe gikk galt", undefined);
            }
            else {
                patternInput_2[1](res_2.fields[0]);
            }
        }));
        void (pr_5.catch((ex_2) => {
            toastServerError(setCtx, ex_2);
        }));
    });
    const el_48 = Dialog;
    return createElement(el_48, createObj(ofArray([["open", !equals(user.State, new UserState(1, []))], (elems_11 = [(el_46 = DialogSurface, createElement(el_46, createObj(singleton_1((elems_10 = [(el_44 = DialogBody, createElement(el_44, createObj(singleton_1((elems_9 = toList(delay(() => {
        let el_4;
        return append(singleton((el_4 = DialogTitle, createElement(el_4, createObj(toList(delay(() => {
            let el_2, el;
            return append(singleton(["action", (el_2 = Button, createElement(el_2, {
                size: "small",
                as: "a",
                children: "Logg ut",
                iconPosition: "after",
                icon: (el = SignOutRegular, createElement(el, {})),
                href: "/api/logout",
            }))]), delay(() => ((user.Workplace == null) ? singleton(["children", "Arbeidsplass kreves"]) : singleton(["children", "Bruker må godkjennes"]))));
        })))))), delay(() => {
            let el_36, elems_7;
            return append(singleton((el_36 = DialogContent, createElement(el_36, createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 5 + "px ",
                alignItems: "center",
            }], (elems_7 = toList(delay(() => {
                let el_6;
                return append(singleton((el_6 = HourglassHalfRegular, createElement(el_6, {
                    style: {
                        fontSize: 96 + "px",
                    },
                    primaryFill: tokens.colorBrandForeground2,
                }))), delay(() => {
                    let elems_6, el_30, el_32, el_34, el_8, value_34;
                    const matchValue = user.Workplace;
                    if (matchValue != null) {
                        const wp_2 = matchValue;
                        return singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }], (elems_6 = [(el_30 = Caption1, createElement(el_30, {
                            children: "Din bruker må godkjennes av en administrator før du kan gå videre i portalen",
                        })), (el_32 = Caption1, createElement(el_32, {
                            style: {
                                marginTop: 15,
                            },
                            children: "Arbeidsplass",
                        })), (el_34 = Body1Strong, createElement(el_34, {
                            children: `${wp_2.Name}`,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                    }
                    else {
                        return append(singleton((el_8 = Caption1, createElement(el_8, createObj(ofArray([["align", "center"], (value_34 = "Din bruker krever en arbeidsplass for å få tilgang til portalen. Velg din arbeidsplass og send til godkjenning av administrator", ["children", value_34])]))))), delay(() => {
                            let el_19, matchValue_1, el_16, elems_1;
                            return append(singleton((el_19 = Field, createElement(el_19, {
                                label: "Arbeidsplass",
                                required: true,
                                children: (matchValue_1 = tryHead([(el_16 = Dropdown, createElement(el_16, createObj(ofArray([["value", defaultArg(map((_arg_1) => _arg_1.Name, selectedWorkplace), "")], ["onOptionSelect", (_arg_2, value_1_12) => {
                                    iterate((selected) => {
                                        patternInput_3[1](tryFind((wp) => (wp.Name === selected), workplaces));
                                    }, toArray(value_1_12.optionValue));
                                }], (elems_1 = toList(delay(() => map_1((wp_1) => {
                                    let elems, el_10, el_12;
                                    const el_14 = Option;
                                    return createElement(el_14, createObj(ofArray([["value", wp_1.Name], (elems = [(el_10 = Text$, createElement(el_10, {
                                        children: wp_1.Name,
                                    })), (el_12 = Caption1, createElement(el_12, {
                                        children: wp_1.Region.Name,
                                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
                                }, workplaces))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
                            }))), delay(() => {
                                let el_28, matchValue_2, el_25, elems_4;
                                return singleton((el_28 = Field, createElement(el_28, {
                                    label: "Tittel",
                                    children: (matchValue_2 = tryHead([(el_25 = Dropdown, createElement(el_25, createObj(ofArray([["placeholder", "Velg tittel (valgfritt)"], ["value", defaultArg(map((_arg_3) => _arg_3.Name, selectedTitle), "")], ["onOptionSelect", (_arg_4, value_1_17) => {
                                        iterate((selected_1) => {
                                            patternInput_4[1](tryFind((t_1) => (t_1.Name === selected_1), titles));
                                        }, toArray(value_1_17.optionValue));
                                    }], (elems_4 = toList(delay(() => map_1((title) => {
                                        let elems_3, el_21;
                                        const el_23 = Option;
                                        return createElement(el_23, createObj(ofArray([["value", title.Name], (elems_3 = [(el_21 = Text$, createElement(el_21, {
                                            children: title.Name,
                                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
                                    }, titles))), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (matchValue_2 == null) ? defaultOf() : matchValue_2),
                                })));
                            }));
                        }));
                    }
                }));
            })), ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))), delay(() => {
                let el_42, elems_8, el_40, el_38;
                return (!equals(user.State, new UserState(1, [])) && (user.Workplace == null)) ? singleton((el_42 = DialogActions, createElement(el_42, createObj(ofArray([["position", "end"], (elems_8 = [(el_40 = Button, createElement(el_40, {
                    disabled: selectedWorkplace == null,
                    icon: (el_38 = SendRegular, createElement(el_38, {})),
                    iconPosition: "after",
                    appearance: "primary",
                    children: "Send",
                    onClick: (_arg_5) => {
                        iterate((wp_3) => {
                            let pr_1;
                            const pr = startAsPromise(User.UpdateUser(user.Id, new UpdatedUser(user.FirstName, user.LastName, user.Email, user.Phone, user.State, user.Role, wp_3.Id, map((_arg_6) => _arg_6.Id, selectedTitle))));
                            pr_1 = (pr.then((res) => {
                                if (res.tag === 1) {
                                    switch (res.fields[0].tag) {
                                        case 1: {
                                            errorToast(setCtx, `updateUser${user.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                                            break;
                                        }
                                        case 2: {
                                            errorToast(setCtx, `updateUser${user.Id}TitleNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig tittel", undefined);
                                            break;
                                        }
                                        case 3: {
                                            errorToast(setCtx, `updateUser${user.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                                            break;
                                        }
                                        case 4: {
                                            errorToast(setCtx, `updateUser${user.Id}InvalidEmail`, "Kunne ikke oppdatere bruker", "Ugyldig e-post", undefined);
                                            break;
                                        }
                                        case 5: {
                                            errorToast(setCtx, `updateUser${user.Id}Internal`, "Kunne ikke oppdatere bruker", "", undefined);
                                            break;
                                        }
                                        default:
                                            errorToast(setCtx, `updateUser${user.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
                                    }
                                }
                                else {
                                    setCtx(new ContextMsg(2, [res.fields[0]]));
                                }
                                return res;
                            }));
                            void (pr_1.catch((ex) => {
                                toastServerError(setCtx, ex);
                            }));
                        }, toArray(selectedWorkplace));
                    },
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])]))))) : empty();
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_9))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])))))], (elemsToUse = ((length(elems_11) <= 2) ? elems_11 : take(2, elems_11)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

const cssOverride = `
      .fui-Caption2.fui-Text {
            color: ${tokens.colorNeutralForeground3};
        }
      .fui-Caption1.fui-Text {
            color: ${tokens.colorNeutralForeground3};
        }
      .fui-NavItem {
          background-color: ${tokens.colorNeutralBackground1};
      }
          background-color: ${tokens.colorSubtleBackgroundInvertedHover};
      .fui-NavItem:hover {
      }
      .fui-NavCategoryItem {
          background-color: ${tokens.colorNeutralBackground1};
      }
          background-color: ${tokens.colorSubtleBackgroundInvertedHover};
      .fui-NavCategoryItem:hover {
      }
      .fui-NavSubItem {
          background-color: ${tokens.colorNeutralBackground1};
      }
          background-color: ${tokens.colorSubtleBackgroundInvertedHover};
      .fui-NavSubItem:hover {
      }

      /* ── Mobile horizontal Card: let the header shrink ──────────────── */
      /* Fluent's horizontal Card lays children out with \`flex: 0 0 auto\`,
         so a long description text inside the cardHeader forces the header
         past the card's own width and clips. Make the header shrinkable so
         the text wraps inside the available space on phones. */
      @media (max-width: 768px) {
        .fui-Card .fui-CardHeader {
          flex: 1 1 auto;
          min-width: 0;
        }
        .fui-Card .fui-CardHeader__header,
        .fui-Card .fui-CardHeader__description {
          min-width: 0;
          overflow-wrap: anywhere;
        }
      }

      /* ── Mobile DataGrid: scroll instead of squish ─────────────────── */
      /* Fluent's DataGrid doesn't ship with a scroll wrapper, so on phones the
         columns get compressed and headers clip. Wrap the grid via its own
         class so it scrolls horizontally instead. */
      @media (max-width: 768px) {
        .fui-DataGrid {
          display: block;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .fui-DataGridHeader,
        .fui-DataGridBody {
          min-width: max-content;
        }
      }

      /* ── Calendar Floating Action Button (Mobile) ──────────────────── */
      /* Reshapes the inline Add-Event trigger button into a 56×56 primary
         circle when it's hosted inside \`.iip-calendar-fab\`. Includes safe-
         area padding so it clears the iOS home-indicator. Only applies in
         the FAB host so other primary buttons stay rectangular. */
      .iip-calendar-fab {
        bottom: calc(16px + env(safe-area-inset-bottom)) !important;
      }
      .iip-calendar-fab .fui-Button {
        width: 56px;
        min-width: 56px;
        height: 56px;
        min-height: 56px;
        padding: 0;
        border-radius: 999px;
        box-shadow: var(--shadow16);
      }
      .iip-calendar-fab .fui-Button__icon {
        font-size: 24px;
      }

      /* ── Mobile dialog: full-screen with sticky footer ─────────────── */
      /* Default Fluent Dialog uses fixed max-height which falls under the
         iOS Safari URL bar / Android keyboard. Make it occupy 100dvh on
         phones and let the action footer stick to the bottom. */
      @media (max-width: 576px) {
        .fui-DialogSurface {
          max-width: 100vw !important;
          max-height: 100dvh !important;
          width: 100vw !important;
          height: 100dvh !important;
          margin: 0 !important;
          border-radius: 0 !important;
          inset: 0 !important;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
        }
        .fui-DialogBody {
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
        }
        .fui-DialogActions {
          position: sticky;
          bottom: 0;
          background: var(--colorNeutralBackground1);
          padding-block: 12px;
          border-top: 1px solid var(--colorNeutralStroke2);
        }
      }
    `;

function Application() {
    let elements, elems_1;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    useEffectOnce(() => {
        const pr = tap((res) => {
            if (res.tag === 1) {
            }
            else {
                setCtx(new ContextMsg(6, [res.fields[0]]));
            }
        }, startAsPromise(Track.GetMyInactive()));
        void (pr.catch((_arg_1) => {
        }));
        if (equals(ctx.User.Role, new Role(1, []))) {
            const pr_1 = tap((res_1) => {
                if (res_1.tag === 1) {
                }
                else {
                    setCtx(new ContextMsg(10, [res_1.fields[0]]));
                }
            }, startAsPromise(User.GetPendingApprovalCount()));
            void (pr_1.catch((_arg_2) => {
            }));
        }
    });
    let patternInput_1;
    const initial = RouterModule_urlSegments(window.location.hash, 1);
    patternInput_1 = reactApi.useState(initial);
    const currentUrl = patternInput_1[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isTablet = (equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []))) ? true : equals(screenSize, new ScreenSize(2, []));
    injectCss(cssOverride);
    return RouterModule_router(createObj(ofArray([["hashMode", 1], ["onUrlChanged", patternInput_1[1]], (elements = singleton_1(createElement("div", createObj(ofArray([["style", {
        width: 100 + "vw",
        height: 100 + "vh",
        display: "flex",
        flexDirection: "row",
    }], (elems_1 = toList(delay(() => append(singleton(createElement(Sidebar, {
        currentUrl: currentUrl,
    })), delay(() => {
        let el;
        return append(!isTablet ? singleton((el = Divider, createElement(el, {
            appearance: "subtle",
            vertical: true,
        }))) : empty(), delay(() => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "start",
            }], (elems = toList(delay(() => append(singleton(createElement(RoleBanner, null)), delay(() => append(singleton(createElement(Headerbar, null)), delay(() => (!equals(ctx.User.State, new UserState(1, [])) ? singleton(createElement(ApproveUserDialog, ctx.User)) : singleton(createElement(View, {
                currentPage: pageFromUrl(currentUrl),
            }))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
}

function Root() {
    let value, elems_1, elems, el_2, el;
    const patternInput = reactApi.useState(undefined);
    const session = patternInput[0];
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(User.GetSession());
        pr_1 = (pr.then((r) => {
            if (r.tag === 1) {
                window.location.href = "/api/login";
            }
            else {
                patternInput[1](r.fields[0]);
            }
            return r;
        }));
        void (pr_1.catch((_ex) => {
            window.location.href = "/api/login";
        }));
    });
    if (session != null) {
        const s = session;
        return createElement(ContextProvider, {
            session: s,
            children: singleton_1(createElement(Application, null)),
        });
    }
    else {
        const el_4 = FluentProvider;
        return createElement(el_4, createObj(ofArray([(value = webLightTheme, ["theme", value]), (elems_1 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            height: 100 + "vh",
            width: 100 + "vw",
            flexDirection: "column",
            gap: 5 + "px ",
            justifyContent: "center",
            alignItems: "center",
        }], (elems = [(el_2 = Spinner, createElement(el_2, {
            size: "large",
            labelPosition: "below",
            label: (el = Text$, createElement(el, {
                children: "Logger inn...",
            })),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
    }
}

const root = createRoot(document.getElementById("root"));

root.render((() => {
    const children = singleton_1(createElement(Root, null));
    return reactApi.createElement(reactApi.StrictMode, undefined, ...children);
})());

//# sourceMappingURL=App.jsx.map
